export default {
  // Nav
  "nav.home": "Startseite",
  "nav.products": "Produkte",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Kategorien",
  "nav.guides": "Anleitungen",
  "nav.shoppingGuide": "Einkaufsführer",
  "nav.mainSite": "Hauptwebsite",
  "nav.about": "Über uns",
  "nav.contact": "Kontakt",
  "nav.disclaimer": "Haftungsausschluss",
  "nav.language": "Sprache",

  // Hero
  "hero.badge": "Unabhängige Ressource · Aktualisiert 2026",
  "hero.title": "CSSBuy Spreadsheet: Links, Anleitungen & Ressourcen für besseres Einkaufen",
  "hero.subtitle": "Entdecken Sie das CSSBuy Spreadsheet, beliebte Kategorien, nützliche Ressourcen und erfahren Sie, wie Sie Produkte, QC, Maße, Warehouse und Shipping vor dem Kauf überprüfen.",
  "hero.cta1": "CSSBuy Spreadsheet Erkunden",
  "hero.cta2": "Jetzt Kaufen",
  "hero.trust1": "Unabhängige Ressource",
  "hero.trust2": "Aktualisierte Anleitungen 2026",
  "hero.trust3": "Organisierte Recherche",
  "hero.trust4": "Sicherheitsinformationen",

  // Categories dropdown
  "nav.categories.label": "Kategorien",
  "cat.shoes": "Schuhe / Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jacken / Jackets",
  "cat.pants": "Hosen / Pants & Shorts",
  "cat.headwear": "Kopfbedeckung / Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Unterwäsche / Underwear",
  "cat.jersey": "Trikots / Jersey",
  "cat.accessories": "Zubehör / Accessories",
  "cat.bags": "Taschen / Bags",
  "cat.belts": "Gürtel / Belts",
  "cat.perfumes": "Parfums / Perfumes",
  "cat.other": "Sonstiges / Other Stuff",

  // Products page
  "products.title": "Produktkatalog",
  "products.subtitle": "Erkunden Sie unsere kuratierte Sammlung von Produkten. Klicken Sie auf ein Element, um Details anzuzeigen und zu kaufen.",
  "products.allCategories": "Alle Kategorien",
  "products.searchPlaceholder": "Produkte suchen...",
  "products.clear": "Zurücksetzen",
  "products.showing": "Anzeigen",
  "products.items": "Artikel",
  "products.noResults": "Keine Produkte gefunden",
  "products.viewAll": "Alle Produkte anzeigen",
  "what.title": "Was ist das CSSBuy Spreadsheet?",
  "what.text": "Ein CSSBuy Spreadsheet organisiert Links, Produkte, Kategorien und Einkaufsressourcen in einem einfach durchsuchbaren Format. Unser Ziel ist es, Käufern zu helfen, Informationen zu finden und fundiertere Entscheidungen zu treffen. Dies ist eine unabhängige Ressource, die nicht mit CSSBuy verbunden ist.",
  "what.disclaimer": "Diese Website ist eine unabhängige Informationsressource und ist nicht mit CSSBuy verbunden, von CSSBuy unterstützt oder betrieben.",

  // Categories section
  "cats.title": "Finden Sie, was Sie suchen",
  "cats.subtitle": "Durchsuchen Sie beliebte Kategorien im CSSBuy Spreadsheet",
  "cats.viewAll": "Alle anzeigen",
  "cats.explore": "Erkunden",

  // Why section
  "why.title": "Warum unser CSSBuy Spreadsheet nutzen?",
  "why.1": "Kategorisierte und organisierte Links",
  "why.2": "Einfache und intuitive Kategorien",
  "why.3": "Anleitungen für Einsteiger",
  "why.4": "QC Schritt für Schritt erklärt",
  "why.5": "Shipping verständlich erklärt",
  "why.6": "Warehouse erklärt",
  "why.7": "Nützliche Vergleiche",
  "why.8": "Sicherheitstipps",

  // How it works
  "how.title": "Wie funktioniert es?",
  "how.1.title": "Kategorie finden",
  "how.1.text": "Navigieren Sie durch die CSSBuy Spreadsheet Kategorien.",
  "how.2.title": "Produkte suchen",
  "how.2.text": "Links und Produktinformationen finden.",
  "how.3.title": "Links überprüfen",
  "how.3.text": "Links, Informationen und Details überprüfen.",
  "how.4.title": "Maße & QC prüfen",
  "how.4.text": "Maße, QC-Fotos und Spezifikationen prüfen.",
  "how.5.title": "Optionen vergleichen",
  "how.5.text": "Produkte, Preise und Verkäufer vergleichen.",
  "how.6.title": "Daten bestätigen",
  "how.6.text": "Aktuelle Informationen vor dem Kauf bestätigen.",

  // Popular guides
  "guides.title": "Beliebte Anleitungen",
  "guides.subtitle": "Wesentliche Ressourcen für CSSBuy Spreadsheet Käufer",
  "guides.review": "CSSBuy Erfahrungen",
  "guides.review.desc": "Unabhängige vollständige Analyse zu QC, Warehouse und Shipping.",
  "guides.shipping": "CSSBuy Versandkosten",
  "guides.shipping.desc": "Vollständiger Leitfaden zu Kosten, Methoden und Versandfaktoren.",
  "guides.qc": "CSSBuy QC Anleitung",
  "guides.qc.desc": "QC-Fotos, Maße und Produktqualität überprüfen.",
  "guides.warehouse": "CSSBuy Warehouse Anleitung",
  "guides.warehouse.desc": "Den Warehouse-, Storage- und Konsolidierungsprozess verstehen.",
  "guides.legit": "Ist CSSBuy seriös?",
  "guides.legit.desc": "Unabhängige Analyse von Sicherheit, Zahlung und Zuverlässigkeit.",
  "guides.coupon": "CSSBuy Gutschein",
  "guides.coupon.desc": "Leitfaden zu Gutscheinen, Aktionen und Rabattcodes.",
  "guides.readmore": "Mehr lesen",
  "pillars.title": "Detaillierte Anleitungen & Artikel",
  "pillars.subtitle": "Ausführliche Ressourcen zu QC, Versand, Warehouse, Sicherheit und mehr für CSSBuy-Käufer.",

  // CTA section
  "cta.title": "Finden Sie Ihre nächste Ressource im CSSBuy Spreadsheet",
  "cta.subtitle": "Besuchen Sie die Hauptwebsite, um alle verfügbaren Produkte und Kategorien zu erkunden.",
  "cta.btn1": "CSSBuy Spreadsheet Erkunden",
  "cta.btn2": "cssbuy spreadsheet",
  "cta.btn3": "jetzt kaufen",

  // Safety
  "safety.title": "Sicherheit geht vor",
  "safety.text": "Überprüfen Sie Links, Verkäufer, Maße, QC, Kosten und aktuelle Richtlinien. Teilen Sie niemals Ihr Passwort und bestätigen Sie wichtige Informationen direkt auf der entsprechenden Plattform.",
  "safety.btn": "Sicherheitsleitfaden ansehen",
  "safety.disclaimer": "Diese Website ist eine unabhängige Informationsressource. CSSBuy, Verkäufer, Marktplätze und externe Links werden von ihren jeweiligen Parteien betrieben. Informationen, Preise, Verfügbarkeit und Richtlinien können sich ändern.",

  // FAQ
  "faq.title": "Häufig gestellte Fragen",
  "faq.1.q": "Was ist CSSBuy Spreadsheet?",
  "faq.1.a": "CSSBuy Spreadsheet ist eine organisierte Tabelle mit Links, Produkten, Kategorien und Einkaufsressourcen. Dies ist eine unabhängige Ressource, die Käufern hilft, nützliche Informationen zu finden.",
  "faq.2.q": "Wie verwende ich das CSSBuy Spreadsheet?",
  "faq.2.a": "Durchsuchen Sie die Kategorien, finden Sie relevante Links und Informationen, überprüfen Sie Details wie QC und Maße und besuchen Sie die Hauptwebsite, um Ihren Kauf abzuschließen.",
  "faq.3.q": "Ist CSSBuy Spreadsheet offiziell?",
  "faq.3.a": "Nein. Diese Website ist eine unabhängige Informationsressource und ist nicht mit CSSBuy verbunden, von CSSBuy unterstützt oder betrieben.",
  "faq.4.q": "Wie überprüfe ich einen Link?",
  "faq.4.a": "Greifen Sie immer direkt auf Links zu und überprüfen Sie die Authentizität des Verkäufers auf der entsprechenden Plattform, bevor Sie einen Kauf tätigen.",
  "faq.5.q": "Wie funktioniert QC?",
  "faq.5.a": "QC (Quality Check) sind Fotos des Produkts, die im Warehouse vor dem Versand aufgenommen werden. Sie ermöglichen die Überprüfung von Qualität, Maßen und Zustand.",
  "faq.6.q": "Wie viel kostet der Versand?",
  "faq.6.a": "Die Kosten variieren je nach Gewicht, Volumen, Ziel und Versandmethode. Bestätigen Sie immer den Endpreis vor der Zahlung.",
  "faq.7.q": "Ist CSSBuy seriös?",
  "faq.7.a": "Diese Website präsentiert unabhängige Informationen über CSSBuy, um Käufern zu helfen, informierte Entscheidungen zu treffen. Überprüfen Sie immer aktuelle Informationen direkt auf der Plattform.",
  "faq.8.q": "Gibt es CSSBuy Gutscheine?",
  "faq.8.a": "Gutscheine und Aktionen werden von CSSBuy verwaltet. Sehen Sie sich unseren Gutschein-Leitfaden an und überprüfen Sie die aktuelle Verfügbarkeit direkt auf der Plattform.",

  // Footer
  "footer.desc": "Unabhängige Informationsressource über CSSBuy Spreadsheet. Nicht mit CSSBuy verbunden.",
  "footer.links": "Nützliche Links",
  "footer.categories": "Kategorien",
  "footer.legal": "Rechtliches",
  "footer.privacy": "Datenschutz",
  "footer.terms": "Nutzungsbedingungen",
  "footer.disclaimer": "Haftungsausschluss",
  "footer.about": "Über uns",
  "footer.contact": "Kontakt",
  "footer.copyright": "© 2026 cssbuybr.sbs — Unabhängige Ressource. Nicht mit CSSBuy verbunden.",
  "footer.independent": "Unabhängige Ressource · Nicht mit CSSBuy verbunden",

  // Article page
  "article.backHome": "← Zurück zur Startseite",
  "article.toc": "Inhaltsverzeichnis",
  "article.author": "Redaktionsteam cssbuybr.sbs",
  "article.updated": "Aktualisiert am",
  "article.disclaimer": "Hinweis: Dieser Inhalt ist unabhängig und informativ. Wir sind nicht mit CSSBuy verbunden.",
  "article.readTime": "Min. Lesezeit",

  // About
  "about.title": "Über cssbuybr.sbs",
  "about.text1": "cssbuybr.sbs ist eine unabhängige Informationsressource, die sich auf CSSBuy Spreadsheet konzentriert. Unser Ziel ist es, Käufern zu helfen, organisierte Informationen, nützliche Anleitungen und Ressourcen für fundierte Kaufentscheidungen zu finden.",
  "about.text2": "Diese Website ist nicht mit CSSBuy verbunden, von CSSBuy unterstützt oder betrieben. Alle Informationen basieren auf unabhängiger öffentlicher Recherche.",
  "about.mission": "Unsere Mission",
  "about.missionText": "Organisierte, präzise und nützliche Ressourcen über CSSBuy Spreadsheet für Käufer auf der ganzen Welt bereitzustellen.",
  "about.disclaimer": "Haftungsausschluss",
  "about.disclaimerText": "Diese Website ist eine unabhängige Informationsressource und ist nicht mit CSSBuy verbunden, von CSSBuy unterstützt oder betrieben.",
};